import Image from "@/components/common/Image";
import { useI18n } from "@/common/I18nProvider";

export default function IntegrationHomeOne() {
  const { messages } = useI18n();
  const integration = messages.integration;
  const products = integration.products;

  const productCards = [
    { key: 'transport', icon: '/assets/icons/transport.svg', alt: products.transport.title },
    { key: 'oils', icon: '/assets/icons/oil.svg', alt: products.oils.title },
    { key: 'tires', icon: '/assets/icons/tire.svg', alt: products.tires.title },
    { key: 'batteries', icon: '/assets/icons/battery.svg', alt: products.batteries.title },
    { key: 'spareParts', icon: '/assets/icons/spare-parts.svg', alt: products.spareParts.title },
    { key: 'carAccessories', icon: '/assets/icons/car-parts.svg', alt: products.carAccessories.title },
    { key: 'maintenance', icon: '/assets/icons/maintenance.svg', alt: products.maintenance.title },
    { key: 'distribution', icon: '/assets/icons/distribution.svg', alt: products.distribution.title },
  ];

  return (
    <section className="integration-section bg-secondary ">
      {/* <!-- Divider --> */}
      <div className="divider"></div>

      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-sm-10 col-md-9 col-lg-8 col-xl-7 col-xxl-6">
            <div className="section-heading text-center">
              <span className="subtitle  text-white">{integration.subtitle}</span>
              <h2 className="mb-0 color-change text-white">{integration.title}</h2>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- Divider --> */}
      <div className="divider-sm"></div>

      <div className="container">
        <div className="integration-content">
          {productCards.map((card) => {
            const product = products[card.key as keyof typeof products];
            return (
              <div key={card.key} className="integration-card translateY10">
                <Image src={card.icon} alt={card.alt} width={80} height={80} priority style={{ filter: 'brightness(0) saturate(100%)' }}/>
                <div>
                  <h5>{product.title}</h5>
                  <p>{product.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* <!-- Divider --> */}
      <div className="divider"></div>
    </section>
  )
}
